import Dexie, { type Table } from 'dexie';
import { TABLES } from './tables';

/** A cached nomenclature row: clear indexable fields + an optional encrypted blob. */
export type NomenclatureRow = Record<string, unknown> & { id: number; _enc?: Uint8Array };

/** Key/value store for sync hashes, the crypto key, and sync metadata. */
export interface MetaRow {
  key: string;
  value: unknown;
}

/**
 * IndexedDB for the Azure nomenclature cache (Dexie). One store per table plus
 * a `meta` store. Stores are declared from the central TABLES registry so the
 * schema can't drift from the sync config.
 */
class NomenclatureDB extends Dexie {
  meta!: Table<MetaRow, string>;

  constructor() {
    super('gral_nomenclature');

    const stores: Record<string, string> = { meta: '&key' };
    for (const t of TABLES) stores[t.store] = t.schema;

    this.version(1).stores(stores);
  }

  /** Typed accessor for a nomenclature store by name. */
  rows(store: string): Table<NomenclatureRow, number> {
    return this.table(store);
  }
}

export const db = new NomenclatureDB();
